module.exports = __webpack_public_path__ + "img/no_pic.8f4ef32e.png";